import React, {useMemo} from 'react';
import VStack from './Layout/VStack';
import HStack from "./Layout/HStack";
import {Colors} from "../../styles/Colors";
import {GlobalConsts} from "../../styles/GlobalConsts";
import AppText from "./AppText";
import {GlobalStyleAttributes} from "../../styles/GlobalStyles";
import CustomButtonV2 from "./CustomButtonV2";
import {getFileExtension} from "../../services/Helpers";
import {useSelector} from "react-redux";
import moment from "moment";
import {t} from "../../services/i18n";
import {fetchApi} from "../../services/HTTP";
import orderBy from 'lodash-es/orderBy';
import { Progress } from 'antd';
import FakeProgress from "./FakeProgress";
import usePermissions from "../../services/Permissions";
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

const FilePreviewList = ({files, onRemove, canRemove = true}) => {
    const box = useSelector(state => state.box.box)
    const user = useSelector(state => state.user.user)
    const timeFormat = useMemo(() => box ? box.locations_box[0].time_format : null, [box])
    const dateFormat = useMemo(() => box ? box.locations_box[0].date_format : null, [box])
    const { has } = usePermissions()

    const filesInfo = useMemo(() => {
        let visibleFiles = (files ?? []).filter((file) => !file?.shouldRemove)
        visibleFiles = (visibleFiles ?? []).reduce((acc, file) => {
            const fileName = file?.file_name || file?.name || '';
            const extension = getFileExtension(fileName);
            const isPdf = extension === 'pdf';
            const isImage = IMAGE_EXTENSIONS.includes(extension);
            const sortTimestamp = file?.created_at ? moment(file.created_at).valueOf() : moment().valueOf();
            return [...acc, {
                ...file,
                key: file?.id ?? file?.uid,
                kind: file?.id != null ? 'committed' : 'staged',
                createdAt: file?.created_at ? moment(file.created_at).format(`${dateFormat}, ${timeFormat}`) : moment().format(`${dateFormat}, ${timeFormat}`),
                createdBy: file?.created_by ? file.created_by.full_name : user.full_name,
                fileName,
                extension,
                isImage,
                isPdf,
                sortTimestamp
            }]
        }, [])
        return orderBy(visibleFiles, ['sortTimestamp'], ['desc']);
    }, [files]);

    const viewFileOnClick = async (id) => {
        const result = await fetchApi("formsTypes/viewFile", 'POST', { id: id }, false, true)
        window.open(result);
    }

    const getSubheaderByStatus = (file) => {
        let subheader = null
        switch (file.status) {
            case 'uploading':
                subheader = <FakeProgress status={file.status}/>
                break;
            case 'error':
                subheader = <AppText fontSize={GlobalStyleAttributes.fonts.newBadge} color={Colors.error}>{t(`file-upload-error-${file.errorMessage}`)}</AppText>
                break;
            case 'done':
                subheader = <AppText fontSize={GlobalStyleAttributes.fonts.newBadge} color={Colors.newDesign.darkGrey}>{t('file-commit-info', {createdBy: file.createdBy, createdAt: file.createdAt})}</AppText>
                break;
            default:
                if(file.kind === 'committed') {
                    subheader = <AppText fontSize={GlobalStyleAttributes.fonts.newBadge} color={Colors.newDesign.darkGrey}>{t('file-commit-info', {createdBy: file.createdBy, createdAt: file.createdAt})}</AppText>
                }
                break;
        }
        return subheader
    }

    if (!filesInfo.length) return null;

    return (
        <VStack style={{width: '100%', gap: '0.5rem'}}>
            {filesInfo.map((file) => {
                return (
                    <HStack key={`file-preview-${file.id ?? file.uid}`} style={{alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem', padding: '0.75rem', border: `1px solid ${file.status === 'error' ? Colors.error : Colors.borderColor}`, borderRadius: '4px', backgroundColor: Colors.newDesign.white}}>
                        <VStack width={'stretch'}>
                            <HStack space={'0.5rem'}>
                                <AppText mediumFont fontSize={GlobalStyleAttributes.fonts.infoText} color={file.status === 'error' ? Colors.error : Colors.newDesign.mainText}>{file.fileName}</AppText>
                                {file.id && has('viewForms') && <CustomButtonV2 iconName={'fa-arrow-up-right-from-square'} type={'link'} onClick={() => viewFileOnClick(file.id)} wrapperStyle={{width: 'fit-content'}} tooltipText={t('note-file-tooltip')} iconProps={{iconSize: GlobalConsts.iconSize.XXS}} />}
                            </HStack>
                            {getSubheaderByStatus(file)}
                        </VStack>
                        {canRemove && onRemove &&
                            <CustomButtonV2
                                type={'link'}
                                iconName={'fa-trash-can'}
                                onClick={() => onRemove(file)}
                                iconProps={{iconColor: Colors.error, iconHoverColor: Colors.error}}
                                wrapperStyle={{flexShrink: 0}}
                            />}
                    </HStack>
                )
            })}
        </VStack>
    );
};

export default FilePreviewList;
